module.exports = __webpack_public_path__ + "img/finished-06f0548ae3494870a345632cf0292b59.svg";